module.exports = __webpack_public_path__ + "static/couverture-d5eb5417ddba6229d3faf60df1910d0c.jpg";